import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { CustomBabkaName } from '../../components';
import BabkaLoginClientSection from '../../components/BabkaLogin/BabkaLoginClient';
import { Breadcrumbs, PageHeader } from '../../components/ui';
import { usePaths } from '../../routes/routesHelper';
import { RouteParams } from '../../routes/types';

type Props = RouteComponentProps;

const NavigationSection = ({ history, match }: Props): JSX.Element => {
  const { clientId } = match.params as RouteParams;

  const intl = useIntl();
  const { dashboardPath } = usePaths();

  return (
    <>
      <PageHeader
        title={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <Breadcrumbs
            items={[
              {
                label: intl.messages['dashboard.label'],
                to: dashboardPath()
              },
              {
                label: <CustomBabkaName clientId={clientId} />,
                to: `#`
              }
            ]}
          />
        }
      />
      <BabkaLoginClientSection clientId={clientId} />
    </>
  );
};

export default withRouter(NavigationSection);
